export const printStyles = 
`html,body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Helvetica Neue", Arial, sans-serif;
    height: 100%;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
}

#root {
    height: 100%;
}

body {
    background-color: #eceff4;
}

.sc-content-spinner {
    display: block;
    margin: auto;
    margin-top: 25%;
    width: 25%;
}

.print-page {
    display: none;
}

@media print {
    .print-page {
        display: block;
        margin: 50px;
    }

    .print-page::before { 
        transform: translate3d(0, 0, 0);
      }

    /* Custom styling for builder */
    .slide {
        border-color: #2196f3;
        border-bottom-style: double;
        line-height: 1.9rem;
        position: relative;
    }
    
    .slide[right-open] {
        border-right: none;
    }
    
    .slide[left-open] {
        border-left: none;
    }
    
    .slide[count]::before {
        content: attr(count);
        position: absolute;
        font-size: 8px;
        font-weight: 700;
        background: #2196f3;
        color: white;
        width: 16px;
        height: 10px;
        right: 0;
        text-align: center;
        line-height: 8px;
        box-shadow: 0 0 1px #333;
        bottom: -11px;
        border-top-right-radius: 0;
        border-top-left-radius: 0;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        transition: all 0.2s ease 0s;
    }
}

/* Custom styling for builder */
slide {
    border-color: #2196f3;
    border-bottom-style: double;
    line-height: 1.9rem;
    position: relative;
}

slide[right-open] {
    border-right: none;
}

slide[left-open] {
    border-left: none;
}

slide[count]::before {
    content: attr(count);
    position: absolute;
    font-size: 8px;
    font-weight: 700;
    background: #2196f3;
    color: white;
    width: 16px;
    height: 10px;
    right: 0;
    text-align: center;
    line-height: 8px;
    box-shadow: 0 0 1px #333;
    bottom: -11px;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    transition: all 0.2s ease 0s;
}
#editor {
    line-height: 1.75em;
}

#editor li {
    line-height: 1.6em;
}

/* Custom backgrounds */

.marker-yellow {
    background: #fdfd77;
}

.marker-green {
    background: #63f963;
}

.marker-light-red {
    background: #fc7999;
}

.marker-blue {
    background: #72cdfd;
}

.marker-orange {
    background: #ff9800;
}

.marker-purple {
    background: #ce93d8;
}

.marker-black {
    background: #000000;
    color: #FFFFFF;
}

/* Custom font colors */
.pen-red {
    color: #e91313;
    background: unset;
}

.pen-blue {
    color: #72cdfd;
    background: unset;
}
`